



















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

import PageMain from '@part/layout/PageMain.vue';
import Video from '@fruitpackage/components/Video.vue';
import { PagesService } from '@store/service/PagesService';

/* ----------------------------------------
    Component
---------------------------------------- */

    @Component({
        components: {
            Video,
            PageMain,
        },
        data() {
            return {
                blocks: ''
            };
        },
        created() {
            let pageService = new PagesService(this.$store);
            pageService.getPage('Home').then(response => {
                this.blocks = response.data;
            });
        }
    })

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Home extends Vue {}

